/** KAN-755: мультивыбор групп товаров чекбоксами (скоуп скидки). */
import { Checkbox } from '@/components/ui/checkbox';
import { useProductGroups } from '@/hooks/useDiscounts';

interface GroupMultiPickerProps {
  value: string[];
  onToggle: (id: string) => void;
  disabled?: boolean;
}

export function GroupMultiPicker({ value, onToggle, disabled = false }: GroupMultiPickerProps) {
  const { data, isLoading, isError } = useProductGroups();
  const groups = data ?? [];

  if (isLoading) return <p className="text-sm text-gray-500">Загрузка групп...</p>;
  if (isError) return <p className="text-sm text-red-600">Не удалось загрузить группы</p>;
  if (groups.length === 0) {
    return <p className="text-sm text-gray-500">Групп пока нет. Их создают на вкладке "Группы товаров".</p>;
  }

  return (
    <ul className="max-h-48 space-y-1 overflow-y-auto rounded-md border bg-white p-2" data-testid="group-picker">
      {groups.map((group) => (
        <li key={group.id}>
          <label className="flex items-center gap-2 text-sm text-gray-800">
            <Checkbox
              checked={value.includes(String(group.id))}
              disabled={disabled}
              aria-label={group.name}
              data-testid={`group-check-${group.id}`}
              onCheckedChange={() => onToggle(String(group.id))}
            />
            <span className="truncate">{group.name}</span>
            <span className="text-xs text-gray-400">{group.products_count}</span>
          </label>
        </li>
      ))}
    </ul>
  );
}
